export const dutchDocument = {
  lang: 'nl',
  data: {
    DOCUMENTS: {
      DOCUMENTS: 'Documenten',
      ALL_DOCUMENTS: 'Alle documenten',
      SAVE: 'Opslaan',
      IN_PROGRESS: 'In behandeling',
      SUCCESS: 'Verwerkt door Klippa',
      REJECTED: 'Afgekeurd',
      PROCESSED: 'Verwerkt',
      REJECTED_BEFORE_START_DATE: 'Voor startdatum',
      REJECTED_DUPLICATE: 'Dubbel',
      REJECTED_INVOICE_MANUAL_DELETED: 'Factuur verwijderd',
      REJECTED_NO_INVOICE: 'Factuur Error',
      REJECTED_NOT_READABLE: 'Niet leesbaar',
      REJECTED_OTHERS: 'Afgekeurd',
      REJECTED_SALES_AS_PURCHASE: 'Verkoop als Inkoop',
      REJECTED_PURCHASE_AS_SALES: 'Inkoop als Verkoop',
      DOCUMENT_UPLOADED_SUCCESSFUL: 'Geupload',
      REJECTED_PROCESS_INVOICE_FAILED: 'Factuur maken mislukt',
      FILENAME: 'Naam',
      INVOICENUMBER: 'Factuurnummer',
      INVOICE_DATE: 'Factuurdatum',
      EXPIRE_DATE: 'Vervaldatum',
      STATUS: 'Status',
      STATUSREASON: 'Reden',
      STATUSREMARKS: 'Opmerking',
      LYANTHESTATUS: 'Lyanthe',
      CREATED_AT: 'Aangemaakt op',
      VATCODE: 'BTW code',
      AMOUNT: 'Bedrag',
      DESCRIPTION: 'Omschrijving',
      DEBIT_CREDIT: 'Debit/Credit',
      ENTRY_TYPE_C: 'Credit',
      ENTRY_TYPE_D: 'Debit',
      NAME: 'Naam',
      EMAIL: 'E-mail',
      ADDRESS: 'Adres',
      ZIPCODE: 'Postcode',
      CITY: 'Plaats',
      COUNTRY: 'Land',
      CCNUMBER: 'KVK-nummer',
      VATNUMBER: 'BTW-id',
      VAT: 'BTW',
      SBI: 'SBI codes',
      BRANCH: 'Branch',
      TOTALEX: 'Totaal ex.',
      TOTALVAT: 'Totaal BTW',
      TOTALINC: 'Totaal',
      APPROVE: 'Goedkeuren',
      REJECT: 'Afkeuren',
      APPROVED: 'Document wordt verwerkt',
      FAILED_TO_APPROVE: 'Goedkeuren mislukt',
      BACK: 'Terug',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/main/content/documents/i18n/nl.ts